import {Component, inject} from '@angular/core';
import {NotificationService} from "../../../../services/notification.service";

@Component({
  selector: 'app-accessibility',
  templateUrl: './accessibility.component.html',
  styleUrl: './accessibility.component.scss',
})
export class AccessibilityComponent {

}
